import { render, staticRenderFns } from "./AzOcerizator.vue?vue&type=template&id=16e87970&"
import script from "./AzOcerizator.vue?vue&type=script&lang=js&"
export * from "./AzOcerizator.vue?vue&type=script&lang=js&"
import style0 from "./AzOcerizator.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports